























































































































import parseDate from "@/helpers/parseDate";
import { DateIndex } from "@/models/date-index";
import { format } from "date-fns";
import { Prop, Component, Vue } from "vue-property-decorator";
import VServiceTaskTableCell from "./VServiceTaskTableCell.vue";

export interface Props {
  task: Task;
  date: string; // yyyy-MM-dd
  editable?: boolean;
  idAttr?: string;
}

// TODO: 表示用にflatに整理した方がいいかも
export interface Task {
  id: number;
  name: string;
  status: string;
  startDate: string; // yyyy-MM-dd
  endDate: string; // yyyy-MM-dd
  project: {
    id: number;
    name: string;
    staff: {
      name: string;
    } | null;
  };
  client: {
    name: string;
    staff: {
      name: string;
    } | null;
  } | null;
  otherTasks: {
    shortName: string;
    date: string;
  }[];
  constructionTasks: ConstructionTask[];
  memo: string;
  memoEmphasized: boolean;
}

interface ConstructionTask {
  shortName: string;
  done: boolean;
}

@Component({
  components: { VServiceTaskTableCell }
})
export default class ServiceTaskCell extends Vue {
  @Prop({ required: true }) task!: Task;
  @Prop({ required: true }) date!: string;
  @Prop({ type: Boolean, default: false }) editable!: boolean;
  @Prop({ type: Boolean }) active?: boolean;
  @Prop({}) idAttr!: number;
  @Prop({ default: true }) printMode!: boolean;

  // Thêm data property để quản lý trạng thái tooltip
  private isTooltipVisible = false;

  get onMobile() {
    return this.$store.getters.onMobile;
  }
  get className() {
    // TODO: 正しいステータス表記に合わせる
    switch (this.task.status) {
      case "施工終了":
        return "bg-done";
      case "未着工":
        return "bg-future";
      case "保留":
        return "bg-pending";
      default:
        return "";
    }
  }

  get constructionTasks(): ConstructionTask[] {
    if (this.task.constructionTasks.some(t => t.done)) {
      return this.task.constructionTasks;
    } else {
      return [{ shortName: "未完了", done: false }];
    }
  }

  get dateIndex(): DateIndex {
    const baseDate = new Date();
    return new DateIndex(
      parseDate(this.date, baseDate),
      {
        start: parseDate(this.task.startDate, baseDate),
        end: parseDate(this.task.endDate, baseDate)
      },
      // とりあえず休工日は日曜決めうち
      [0]
    );
  }

  otherTaskDate(date: string): string {
    if (date == "0000-00-00" || !date) {
      return "--";
    }
    return format(parseDate(date), "MM/dd");
  }

  onClick(id: any) {
    //@ts-ignore
    if (window.FlutterChannel) {
      //@ts-ignore
      window.FlutterChannel.postMessage(
        JSON.stringify({ event: "GO_TO_PROJECT_DETAIL", data: id.toString() })
      );
    }
  }

  get showTooltipIcon(): boolean {
    return this.task && this.task.memo != "";
  }

  get tooltipId(): string {
    return `tooltip-memo-${this.idAttr}`;
  }

  // Toggle tooltip
  toggleTooltip(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    this.$nextTick(() => {
      this.isTooltipVisible = !this.isTooltipVisible;
    });
  }

  closeTooltip() {
    this.isTooltipVisible = false;
  }

  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    document.addEventListener("touchstart", this.handleClickOutside);
  }

  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
    document.removeEventListener("touchstart", this.handleClickOutside);
  }

  private handleClickOutside(event: Event) {
    const iconElement = document.querySelector(`#${this.tooltipId}`);
    const tooltipElement = document.querySelector(".tooltip");

    if (iconElement && iconElement.contains(event.target as Node)) {
      return;
    }

    if (tooltipElement && tooltipElement.contains(event.target as Node)) {
      return;
    }

    this.closeTooltip();
  }

  get user() {
    return this.$store.state.user;
  }
}
